import React from 'react'
// import AnimateImageOne from './AnimateImageOne'
import AnimateTitleOne from './AnimatedTitleOne'

const DesignBrief = () => {
    return (
        <section className='section-design-breif section-padding'>
            <div className='container'>
                <div className='row'>
                {/* <div className='col-md-5'>
                    <div className='animated-image-wrapper text-center'>
                        <AnimateImageOne/>
                    </div>
                </div> */}
                <div className='col-12'>
                   <div className='section-content-wrapper'>
                     <div className='section-title'>
                        <AnimateTitleOne/>
                     </div>
                     <div className='section-paragraph'>
                        <p>Each season begins with inspiration. A design brief or theme, shared by our clients or conceptualized by <strong>Ms. Parul,</strong> which sets the creative direction for our team. It outlines the narrative, the textures, and the direction that will guide the embroidery story of the upcoming collection. This is where vision meets possibility — a blueprint for creativity that reflects the essence of contemporary fashion while honoring traditional artistry.</p>
                     </div>
                   </div>
                </div>
                </div>
            </div>
        </section>
    )
}

export default DesignBrief